<script setup>
defineProps({
  isVisible: { type: Boolean, default: false },
  type: { type: String, default: 'success' },
  title: { type: String, default: '' },
  message: { type: String, default: '' }
})

const emit = defineEmits(['close'])

const getIcon = (type) => {
  switch (type) {
    case 'success': return 'fa-check-circle'
    case 'error': return 'fa-times-circle'
    case 'warning': return 'fa-exclamation-triangle'
    default: return 'fa-info-circle'
  }
}

const getColor = (type) => {
  switch (type) {
    case 'success': return 'bg-green-500'
    case 'error': return 'bg-red-500'
    case 'warning': return 'bg-yellow-500'
    default: return 'bg-blue-500'
  }
}
</script>

<template>
  <teleport to="body">
    <transition
      enter-active-class="transition-all duration-300 ease-out"
      leave-active-class="transition-all duration-300 ease-in"
      enter-from-class="opacity-0 translate-x-full"
      enter-to-class="opacity-100 translate-x-0"
      leave-from-class="opacity-100 translate-x-0"
      leave-to-class="opacity-0 translate-x-full"
    >
      <div
        v-if="isVisible"
        class="fixed top-4 right-4 z-50 max-w-md w-full"
      >
        <div class="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
          <div class="flex items-start p-4">
            <div
              :class="['flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-white', getColor(type)]"
            >
              <i :class="['fas', getIcon(type), 'text-sm']"></i>
            </div>
            <div class="ml-3 flex-1 min-w-0">
              <div class="font-medium text-gray-900">{{ title || type }}</div>
              <p v-if="message" class="text-sm text-gray-600 mt-0.5">{{ message }}</p>
            </div>
            <button
              @click="emit('close')"
              class="flex-shrink-0 text-gray-400 hover:text-gray-600"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>
